import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAmazonBookSearchBase } from './useAmazonBookSearchBase'
import { BookResult, SortDecision } from '../types'

interface BookData {
  title?: string
  author?: string
  isbn?: string
  language?: string
  publisher?: string
  category?: string
  imageUrl?: string
  asin?: string
  listingPrice?: number
  shippingPrice?: number
  packageWeight?: number
  salesRank?: number
  length?: number
  width?: number
  height?: number
  weight?: number
  highestSalesRankCategory?: string
  classifications?: {
    classificationId: string
    displayName: string
  }
  commission: number
  profit: number
  uspsShippingCost: number
  closingFee: number
  timeToReturnResult: number
  timeToScan: number
  scanResult: string
  numResultsReturned: number
}

export const useAmazonBookSearchWithNavigation = () => {
  const navigate = useNavigate()

  const handleSortDecisionChange = React.useCallback(
    (decision: SortDecision, selectedBook: BookResult | null, _selectedIndex: number | null) => {
      if (decision === 'ecommerce' && selectedBook) {
        const bookData: BookData = {
          title: selectedBook.title,
          author: selectedBook.author,
          publisher: selectedBook.publisher,
          isbn: selectedBook.isbn,
          imageUrl: selectedBook.mainImageUrl,
          asin: selectedBook.asin,
          listingPrice: selectedBook.listingPrice,
          shippingPrice: selectedBook.shippingPrice,
          packageWeight: selectedBook.packageWeight,
          salesRank: selectedBook.salesRank,
          weight: selectedBook.packageWeight,
          length: selectedBook.packageLength,
          width: selectedBook.packageWidth,
          height: selectedBook.packageHeight,
          highestSalesRankCategory: selectedBook.highestSalesRankCategory,
          classifications: selectedBook.classifications,
          timeToReturnResult: selectedBook.timeToReturnResult,
          timeToScan: selectedBook.timeToScan,
          scanResult: selectedBook.scanResult,
          numResultsReturned: selectedBook.numResultsReturned,
          commission: selectedBook.commission,
          profit: selectedBook.profit,
          uspsShippingCost: selectedBook.uspsShippingCost,
          closingFee: selectedBook.closingFee
        }

        setTimeout(() => {
          navigate('/scan-to-list-books/new-listing', { state: { bookData } })
        }, 1000)
      }
    },
    [navigate]
  )

  return useAmazonBookSearchBase({
    initialSortDecision: 'none',
    onSortDecisionChange: handleSortDecisionChange
  })
}
